import React from 'react';
import { useSearchParams, useParams } from 'react-router-dom';
import PrintIcon from '@mui/icons-material/Print';
import { Upload } from '../../../../../components/atoms/icons';
import './style.scss';
import useScheduledRestocking from './hooks';
import RenderItem from './RenderItem';
import Search from '../../../../../components/molecules/forms/search';
import AddHeader from '../../../../../components/layout/header/add';
import Forms from '../../../../../components/organisms/forms';
import useDateRangePicker from '../../../../../components/organisms/forms/date-range-picker/reusable-func';
import api from '../../../../../components/api';

function ScheduledRestocking(): React.ReactElement {
  const {
    resultData, onDecreaseCount, onIncreaseCount,
    searchValue, handleSearchChange, selectedDate, handleChangeEndDate, handleChangeStartDate,
    vmType, schDateStr, handleCoffeeSalesUpdate,
  } = useScheduledRestocking();
  const { id } = useParams();

  // const [dateRange, setDateRange] = React.useState({});
  // const { handleChangeStartDate, handleChangeEndDate, selectedDate } = useDateRangePicker();
  // setDateRange(selectedDate);
  console.log('result data', resultData);

  const generatePDF = async (vmId: string | number) => {
    const pdfData = (vmType === '4') || (vmType === '5') ? await api.vendingMachine.getCoffeeOrderPDF(vmId!, schDateStr) : await api.vendingMachine.getPDFByVmId({ ...selectedDate, vmId });
    // const pdfData = await api.vendingMachine.getPDFByVmId({ ...selectedDate, vmId });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(pdfData?.data);
    link.target = '_blank';
    // link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();

    // cleanup
    setTimeout(() => {
      link?.parentNode?.removeChild(link);
    }, 3000);
  };

  return (
    <div>
      <AddHeader
        primary={{ route: '/routes/schedule', title: 'Routes Schedule' }}
        title="Re-stocking"
        topRightItem={(
          <div className="d-flex gap-2">
            <PrintIcon sx={{ fontSize: '30px' }} onClick={() => generatePDF(id!)} />
            <button
              onClick={handleCoffeeSalesUpdate}
              type="button"
              className="border-0 bg-transparent"
              disabled={!(vmType === '4' || vmType === '5')}
            >
              <Upload />
            </button>
          </div>
        )}
      />
      <div className="px-4 px-xl-5 mb-4" style={{ height: '42px' }}>
        <Search
          value={searchValue}
          onChange={(e) => handleSearchChange(e.target.value)}
          placeholder="Search..."
        />
      </div>
      <div className="col-xl-3 mx-5 col-lg-4  col-md-6 col-sm-12 mb-4 mb-md-0">
        <Forms.DateRangePicker
          id="dateRangePicker"
          handleChangeStart={handleChangeStartDate}
          handleChangeEnd={handleChangeEndDate}
          startDate={{ current: new Date(selectedDate.start), max: new Date(selectedDate.end) }}
          endDate={{ current: new Date(selectedDate.end), min: new Date(selectedDate.start) }}
        />
      </div>
      {resultData.length ? resultData.map((inventory, i) => (
        <div key={inventory.id}>
          <RenderItem
            position={inventory.apCode}
            title={inventory.productName}
            price={inventory.price}
            count={inventory.quantity}
            className={i % 2 ? 'colored-background' : ''}
            onNegativeClick={() => onDecreaseCount(inventory, i)}
            onPositiveClick={() => onIncreaseCount(inventory, i)}
          />
        </div>
      )) : (
        <div className="fz-14 px-4 px-xl-5">Data not found</div>
      )}
    </div>
  );
}

export default ScheduledRestocking;
